import { useState, useMemo, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { Link } from "uikit-react";
import { AppContexts } from "../../../providers";

const ReportsNavbar = () => {
  const {
    active,
    setActive,
  } = useContext(AppContexts.ReportsContext);

  const history = useHistory();
  const pathArray = useMemo(
    () => history.location.pathname.split("/"),
    [history.location.pathname]
  );
  const path = pathArray[pathArray.length - 1].replace("#", "");
  const [expanded, setExpanded] = useState(null);

  const reportTabs = [
    { path: "overview", label: "Overview" },
    {
      label: "Logs",
      subItems: [
        { path: "message-log", label: "Text Message" },
        { path: "reply-logs", label: "AI Guest Reply" },
        { path: "chatbot-logs", label: "AI Chatbot" },
        { path: "webchat", label: "Webchat" },
        { path: "smart-lock-logs", label: "Smart Lock" },
      ],
    },
    {
      label: "Guestbook Analytics",
      subItems: [
        { path: "guestbook-views", label: "Guestbook Views" },
        { path: "guestbook-by-guest", label: "Guestbook Views By Guest" },
        { path: "guestbook-by-device", label: "Guestbook Views By Device" },
        { path: "extras-views", label: "Extras Views" },
        { path: "home-guide-views", label: "Home Guide Views" },
        { path: "area-guide-views", label: "Area Guide Views" },
      ],
    },
    {
      label: "Guest Responses",
      subItems: [
        { path: "fivestar-rating", label: "Five Star Ratings" },
        { path: "check-in-out", label: "Check-In/Check-Out" },
        { path: "request-check-in-out", label: "Request Early Check-In/Late Check-Out" },
      ],
    },
    {
      label: "Messages Sent",
      subItems: [
        { path: "automated-sms-sent", label: "Automated Text" },
        { path: "automated-email-sent", label: "Automated Emails" },
        { path: "extend-stay", label: "Extend Stays Text" },
      ],
    },
    {
      label: "Extras Orders",
      subItems: [
        { path: "orders-details", label: "Order Details" },
        { path: "orders-income-by-item", label: "Income By Item" },
      ],
    },
    { path: "booking-source-mapping", label: "Booking Source Mapping" },
  ];

  useEffect(() => {
    if (path === "reports") {
      history.push("/reports/overview");
      return;
    }

    setActive(path);

    const matchingParent = reportTabs.find(
      (item) => item.subItems?.some((subItem) => subItem.path === path)
    );

    if (matchingParent) {
      setExpanded(matchingParent.label);
    }

    const unlisten = history.listen((location) => {
      const newPath = location.pathname.split("/").pop().replace("#", "");
      setActive(newPath);

      const nextParent = reportTabs.find(
        (item) => item.subItems?.some((subItem) => subItem.path === newPath)
      );

      if (nextParent) {
        setExpanded(nextParent.label);
      }
    });

    return () => unlisten();
  }, [path, history]);

  const toggleExpand = (label) => {
    setExpanded((prev) => (prev === label ? null : label));
  };

  const handleNavigation = (path, parentLabel) => {
    setActive(path);
    history.push(`/reports/${path}`);

    if (parentLabel) {
      setExpanded(parentLabel);
    } else {
      setExpanded(null);
    }
  };

  const isParentActive = (subItems = []) =>
    subItems.some((subItem) => subItem.path === active);

  return (
    <aside className="hms-section-nav-wrap uk-width-auto">

      <ul className="hms-section-nav">
        {reportTabs.map((item) => {
          if (item.path) {
            return (
              <li
                key={item.path}
                className={active === item.path ? "is-active" : ""}
                onClick={() => handleNavigation(item.path)}
              >
                <Link>{item.label}</Link>
              </li>
            );
          }

          const open = expanded === item.label;
          const parentActive = isParentActive(item.subItems);

          return (
            <li
              key={item.label}
              className={`hms-section-nav-group ${parentActive ? "is-active-group" : ""}`}
            >
              <button
                type="button"
                className={`hms-section-nav-group-toggle ${open ? "is-open" : ""}`}
                onClick={() => toggleExpand(item.label)}
                aria-expanded={open ? "true" : "false"}
              >
                <span>{item.label}</span>
                <span className={`hms-section-nav-chevron ${open ? "open" : ""}`}>
                  <span uk-icon="chevron-down"></span>
                </span>
              </button>

              {open && (
                <ul className="hms-section-subnav">
                  {item.subItems.map((subItem) => (
                    <li
                      key={subItem.path}
                      className={active === subItem.path ? "is-active" : ""}
                      onClick={() => handleNavigation(subItem.path, item.label)}
                    >
                      <Link>{subItem.label}</Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          );
        })}
      </ul>
    </aside>
  );
};

export default ReportsNavbar;